const config = {
  env: "local",
  // apiUrl: "http://localhost:8080/admin/",
  // apiUrl: "http://59.148.248.92:5641/admin/",
  	apiUrl: "https://api.pruden.com.hk/admin/",
    
  // apiUrl: "https://api.mentblue.com/admin",
  // apiUrl: "http://115.246.77.236:5641/admin",
  // apiUrl: "https://api.amourtrendss.com/admin/",
};

export default config;
